var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: 1,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 33",
    style: {
      enableBackground: "new 0 0 32 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.6,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,2.6c-2.9,0-5.7,1.2-7.8,3.2C6.2,7.9,5,10.6,5,13.6c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5l8.4,9.9 l8.4-10c0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6c0-2.9-1.2-5.7-3.2-7.8C21.7,3.7,18.9,2.6,16,2.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerFull);
export default __webpack_public_path__ + "static/media/marker-full.fbf072d79862ec162275a5532c737f56.svg";
export { ForwardRef as ReactComponent };